import type { TabNavItem } from '@mercedes-benz/odp-theme-v2';
import { DocumentIcon, RelationsIcon } from '@mercedes-benz/odp-theme-v2';
import InfoIcon from '@mui/icons-material/Info';
import SchoolIcon from '@mui/icons-material/School';
import { useEntity } from '@backstage/plugin-catalog-react';
import { EntityPageLayout } from './EntityPageLayout';
import { CoreDetailsTab } from '../system-details/CoreDetailsTab';
import { RelationsTab } from '../system-details/RelationsTab';
import { DocsTab } from './DocsTab';
import { CodelabTab } from './CodelabTab';

export const AcademyEntityPage = () => {
  const { entity } = useEntity();
  const isTutorial = entity.spec?.type?.toString().toLowerCase() === 'tutorial';

  const tabs: TabNavItem[] = [
    { id: 'overview', label: 'Overview', icon: InfoIcon },
    { id: 'docs', label: 'Docs', icon: DocumentIcon },
    ...(isTutorial
      ? [{ id: 'codelab', label: 'Detail', icon: SchoolIcon }]
      : []),
    { id: 'relations', label: 'Relations', icon: RelationsIcon },
  ];

  return (
    <EntityPageLayout tabs={tabs}>
      {activeTab => (
        <>
          {activeTab === 'overview' && <CoreDetailsTab />}
          {activeTab === 'docs' && <DocsTab />}
          {activeTab === 'codelab' && <CodelabTab />}
          {activeTab === 'relations' && <RelationsTab />}
        </>
      )}
    </EntityPageLayout>
  );
};
